import styles from "./Toast.module.scss";

interface IProps {
  closeToast?: () => void;
  title: string;
  message?: string;
  style: string;
  link?: string;
  linkText?: string;
}

const Toast: React.FC<IProps> = ({
  closeToast,
  title,
  message,
  style,
  link,
  linkText,
}: IProps) => {
  if (link) {
    return (
      <div className={styles.toast + " " + styles[style]}>
        <img
          src={`${import.meta.env.VITE_BASE_PATH}/images/close-gray.svg`}
          alt="close"
          className={styles.toastClose}
          onClick={closeToast}
        />
        <a href={link} rel="noopener noreferrer">
          <h1>{title}</h1>
          {message && <p>{message}</p>}
          {linkText && <p>{linkText}</p>}
        </a>
      </div>
    );
  } else {
    return (
      <div className={styles.toast + " " + styles[style]} onClick={closeToast}>
        <h1>
          {title}
          <img
            src={`${import.meta.env.VITE_BASE_PATH}/images/close-gray.svg`}
            alt="close"
          />
        </h1>
        {message && <p>{message}</p>}
      </div>
    );
  }
};

export default Toast;
